<div class="min-h-screen bg-slate-50 text-slate-900 dark:bg-[#09090b] dark:text-slate-100 flex flex-col antialiased selection:bg-emerald-600 selection:text-white transition-colors duration-200">
  <header class="border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-900/80 backdrop-blur px-4 py-3 flex items-center justify-between shadow-xs">
    <div class="flex items-center space-x-2">
      <span class="w-2.5 h-2.5 rounded-full bg-emerald-600 animate-pulse"></span>
      <span class="text-xs font-bold tracking-wider uppercase text-slate-700 dark:text-slate-300">
        League of Managers
      </span>
    </div>

    <div class="relative">
      <!-- Settings Wheel Menu Button -->
      <button
        type="button"
        (click)="toggleSettingsMenu()"
        id="btn-register-settings"
        [title]="game.t('nav.settings')"
        class="flex items-center space-x-1.5 p-2 text-slate-600 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors cursor-pointer border border-slate-200 dark:border-slate-700/60"
      >
        <app-icon name="settings" [size]="16" />
      </button>

      @if (isSettingsMenuOpen()) {
        <!-- Backdrop click overlay -->
        <div (click)="closeSettingsMenu()" class="fixed inset-0 z-40"></div>

        <div class="absolute right-0 mt-2 w-64 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-xl py-2 z-50 text-xs transition-colors">
          <div class="px-3 py-1.5 text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider border-b border-slate-100 dark:border-slate-800">
            {{ game.t('nav.settings') }}
          </div>

          <div class="p-1 space-y-0.5">
            <!-- Modo Oscuro / Claro -->
            <button
              type="button"
              (click)="game.toggleDarkMode()"
              id="register-menu-theme"
              class="w-full flex items-center justify-between px-3 py-2 rounded-xl text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
            >
              <div class="flex items-center space-x-2.5">
                @if (game.isDarkMode()) {
                  <app-icon name="sun" [size]="16" class="text-amber-400" />
                  <span class="font-medium">{{ game.t('nav.toggle_theme_light') }}</span>
                } @else {
                  <app-icon name="moon" [size]="16" class="text-slate-600 dark:text-slate-300" />
                  <span class="font-medium">{{ game.t('nav.toggle_theme_dark') }}</span>
                }
              </div>
              <div class="w-8 h-4.5 rounded-full p-0.5 transition-colors" [ngClass]="game.isDarkMode() ? 'bg-emerald-600' : 'bg-slate-300 dark:bg-slate-700'">
                <div class="w-3.5 h-3.5 rounded-full bg-white transition-transform" [ngClass]="game.isDarkMode() ? 'translate-x-3.5' : 'translate-x-0'"></div>
              </div>
            </button>

            <!-- Cambiar Idioma -->
            <div class="pt-1 border-t border-slate-100 dark:border-slate-800">
              <div class="px-3 py-1 text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider flex items-center justify-between">
                <span class="flex items-center space-x-1.5">
                  <app-icon name="globe" [size]="12" />
                  <span>{{ game.t('nav.language') }}</span>
                </span>
                <span class="font-mono text-[10px] text-emerald-600 dark:text-emerald-400 font-semibold">{{ game.i18n.currentLanguageOption().shortCode }}</span>
              </div>

              <div class="grid grid-cols-2 gap-1 px-1.5 py-1">
                @for (lang of game.i18n.availableLanguages; track lang.code) {
                  <button
                    type="button"
                    (click)="selectLanguage(lang.code)"
                    [id]="'register-menu-lang-' + lang.code"
                    class="flex items-center space-x-1.5 px-2 py-1.5 rounded-lg text-left cursor-pointer transition-colors"
                    [ngClass]="game.i18n.currentLanguage() === lang.code ? 'bg-emerald-50 dark:bg-emerald-950/50 text-emerald-700 dark:text-emerald-400 font-bold border border-emerald-200 dark:border-emerald-800/60' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 border border-transparent'"
                  >
                    <span class="text-sm leading-none">{{ lang.flag }}</span>
                    <span class="text-[11px] truncate">{{ lang.nativeName }}</span>
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </header>

  <main class="flex-1 flex items-center justify-center p-4">
    <div class="w-full max-w-md space-y-6">
      <!-- Brand Header -->
      <div class="text-center space-y-3">
        <img
          src="/icons/lom-192.png"
          alt="LOM — League of Managers"
          width="96"
          height="96"
          class="inline-block w-24 h-24 rounded-2xl object-contain shadow-md"
        />

        <div>
          <h1 class="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight">
            League of Managers
          </h1>
          <p class="mt-1 text-sm text-slate-500 dark:text-slate-400">
            {{ game.t('auth.register_subtitle') }}
          </p>
        </div>
      </div>

      <!-- Register Card -->
      <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 sm:p-8 shadow-sm dark:shadow-2xl transition-colors">
        
        @if (isRegisteredSuccess()) {
          <!-- Neutral Confirmation Message (202 Accepted) -->
          <div class="space-y-5 text-center" role="status">
            <div class="w-14 h-14 mx-auto rounded-full bg-emerald-100 dark:bg-emerald-950/60 text-emerald-600 dark:text-emerald-400 flex items-center justify-center shadow-xs">
              <app-icon name="mail" [size]="28" />
            </div>

            <div class="space-y-2">
              <h2 class="text-lg font-bold text-slate-900 dark:text-white">
                {{ game.t('auth.register_success_title') }}
              </h2>
              <p class="text-sm text-slate-600 dark:text-slate-300 leading-relaxed px-2">
                {{ game.t('auth.register_success_neutral_msg') }}
              </p>
            </div>

            @if (resendFeedback()) {
              <div class="p-3 bg-slate-100 dark:bg-slate-800/80 rounded-xl text-xs text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-slate-700" role="status">
                {{ resendFeedback() }}
              </div>
            }

            <div class="pt-3 space-y-3">
              <button
                type="button"
                id="btn-register-resend"
                (click)="handleResend()"
                [disabled]="resendCooldown() > 0 || isResending()"
                class="w-full flex items-center justify-center space-x-2 py-2.5 px-4 rounded-xl text-xs font-semibold text-slate-700 dark:text-slate-200 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 transition-all border border-slate-200 dark:border-slate-700 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              >
                @if (isResending()) {
                  <app-icon name="loader" [size]="14" class="animate-spin text-emerald-600" />
                  <span>{{ game.t('auth.resend_sending') }}</span>
                } @else if (resendCooldown() > 0) {
                  <app-icon name="clock" [size]="14" />
                  <span>{{ game.t('auth.resend_wait', { seconds: resendCooldown() }) }}</span>
                } @else {
                  <app-icon name="refresh-cw" [size]="14" />
                  <span>{{ game.t('auth.resend_btn') }}</span>
                }
              </button>

              <a
                routerLink="/login"
                [fragment]="invitationFragment"
                id="link-go-to-login"
                class="w-full flex items-center justify-center space-x-2 py-3 px-4 rounded-xl text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 transition-all shadow-xs cursor-pointer"
              >
                <span>{{ game.t('auth.verify_go_to_login') }}</span>
                <app-icon name="arrow-right" [size]="16" />
              </a>
            </div>
          </div>
        } @else {
          <!-- Form View -->
          <div class="mb-6 pb-4 border-b border-slate-100 dark:border-slate-800/80">
            <h2 class="text-base font-bold text-slate-900 dark:text-white">
              {{ game.t('auth.register_title') }}
            </h2>
            <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
              {{ game.t('auth.enter_credentials') }}
            </p>
          </div>

          @if (errorMessage()) {
            <div class="mb-4 p-3.5 rounded-xl bg-rose-50 dark:bg-rose-950/60 border border-rose-200 dark:border-rose-900 text-rose-800 dark:text-rose-200 text-xs flex items-start space-x-2.5" role="alert">
              <app-icon name="alert-circle" [size]="18" class="shrink-0 text-rose-600 dark:text-rose-400 mt-0.5" />
              <div class="flex-1 font-medium">
                {{ errorMessage() }}
              </div>
            </div>
          }

          <form [formGroup]="registerForm" (ngSubmit)="handleRegister()" class="space-y-4">
            <!-- Email -->
            <div>
              <label class="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5" for="register-email-input">
                {{ game.t('auth.email') }}
              </label>
              <div class="relative rounded-xl shadow-xs">
                <input
                  id="register-email-input"
                  type="email"
                  formControlName="email"
                  maxlength="254"
                  class="block w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all"
                  placeholder="manager@ejemplo.com"
                />
              </div>
              @if (registerForm.get('email')?.touched && registerForm.get('email')?.errors) {
                @if (registerForm.get('email')?.errors?.['required']) {
                  <p class="text-[11px] text-rose-500 mt-1">{{ game.t('auth.err_email_required') }}</p>
                } @else if (registerForm.get('email')?.errors?.['email']) {
                  <p class="text-[11px] text-rose-500 mt-1">{{ game.t('auth.email_invalid') }}</p>
                } @else if (registerForm.get('email')?.errors?.['maxlength']) {
                  <p class="text-[11px] text-rose-500 mt-1">{{ game.t('auth.email_max_length') }}</p>
                }
              }
            </div>

            <!-- Password -->
            <div>
              <label class="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5" for="register-password-input">
                {{ game.t('auth.password') }}
              </label>
              <div class="relative rounded-xl shadow-xs">
                <input
                  id="register-password-input"
                  type="password"
                  formControlName="password"
                  maxlength="128"
                  class="block w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all"
                  placeholder="••••••••••••"
                />
              </div>
              @if (registerForm.get('password')?.touched && registerForm.get('password')?.errors) {
                @if (registerForm.get('password')?.errors?.['required']) {
                  <p class="text-[11px] text-rose-500 mt-1">{{ game.t('auth.err_password_required') }}</p>
                } @else if (registerForm.get('password')?.errors?.['minlength']) {
                  <p class="text-[11px] text-rose-500 mt-1">{{ game.t('auth.password_min_length') }}</p>
                } @else if (registerForm.get('password')?.errors?.['maxlength']) {
                  <p class="text-[11px] text-rose-500 mt-1">{{ game.t('auth.password_max_length') }}</p>
                }
              }
            </div>

            <!-- Repeat Password -->
            <div>
              <label class="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5" for="register-repeat-password-input">
                {{ game.t('auth.repeat_password') }}
              </label>
              <div class="relative rounded-xl shadow-xs">
                <input
                  id="register-repeat-password-input"
                  type="password"
                  formControlName="repeatPassword"
                  maxlength="128"
                  class="block w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all"
                  placeholder="••••••••••••"
                />
              </div>
              @if (registerForm.get('repeatPassword')?.touched && registerForm.get('repeatPassword')?.errors?.['required']) {
                <p class="text-[11px] text-rose-500 mt-1">{{ game.t('auth.repeat_password_required') }}</p>
              } @else if ((registerForm.get('repeatPassword')?.touched || registerForm.get('password')?.touched) && registerForm.errors?.['passwordMismatch']) {
                <p class="text-[11px] text-rose-500 mt-1">{{ game.t('auth.passwords_must_match') }}</p>
              }
            </div>

            <div class="pt-3">
              <button
                type="submit"
                id="btn-submit-register"
                [disabled]="isSubmitting() || registerForm.invalid"
                class="w-full flex items-center justify-center space-x-2 py-3 px-4 rounded-xl text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 transition-all shadow-xs disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer active:scale-98"
              >
                @if (isSubmitting()) {
                  <app-icon name="loader" [size]="16" class="animate-spin text-white" />
                  <span>{{ game.t('auth.register_creating') }}</span>
                } @else {
                  <span>{{ game.t('auth.register_btn') }}</span>
                  <app-icon name="arrow-right" [size]="16" />
                }
              </button>
            </div>
          </form>

          <div class="mt-6 pt-4 border-t border-slate-100 dark:border-slate-800/80 text-center">
            <a
              routerLink="/login"
              [fragment]="invitationFragment"
              id="link-to-login"
              class="text-xs font-semibold text-emerald-600 hover:text-emerald-700 dark:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
            >
              {{ game.t('auth.has_account') }}
            </a>
          </div>
        }

      </div>
    </div>
  </main>

  <footer class="border-t border-slate-200 dark:border-slate-800 py-3 text-xs text-slate-400 dark:text-slate-500 text-center">
    <span class="font-mono text-[11px]">{{ game.appVersionTag }}</span>
  </footer>
</div>
